import * as React from 'react';

const MailIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#E8F2FF" />
    <mask
      id="mask0_15763_102782"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15763_102782)">
      <path
        d="M12 28C11.45 28 10.9792 27.8042 10.5875 27.4125C10.1958 27.0208 10 26.55 10 26V14C10 13.45 10.1958 12.9792 10.5875 12.5875C10.9792 12.1958 11.45 12 12 12H28C28.55 12 29.0208 12.1958 29.4125 12.5875C29.8042 12.9792 30 13.45 30 14V26C30 26.55 29.8042 27.0208 29.4125 27.4125C29.0208 27.8042 28.55 28 28 28H12ZM20 21L28 16V14L20 19L12 14V16L20 21Z"
        fill="#003594"
      />
    </g>
  </svg>
);

export default MailIcon;
